import BootstrapModalManager from 'react-bootstrap/utils/BootstrapModalManager';

// react-overlays 1.x supplies `dialog`, while its sibling aria helper expects
// `root`. Bridge the bundled versions so the open dialog remains accessible.
class SupportModalManager extends BootstrapModalManager {
  add(modal, container, className) {
    Object.assign(modal, { root: modal.dialog });
    return super.add(modal, container, className);
  }
}
export default new SupportModalManager();
